import {WalkthroughDefinition} from '../types';

export const PROFILE_TOUR_TARGETS = {
  title: 'profile.title',
  header: 'profile.header',
  general: 'profile.general',
  locations: 'profile.locations',
  benefits: 'profile.benefits',
  media: 'profile.media',
  edit: 'profile.edit',
} as const;

export const companyProfileWalkthrough: WalkthroughDefinition = {
  id: 'companyProfile',
  version: 1,
  steps: [
    {
      target: PROFILE_TOUR_TARGETS.title,
      titleKey: 'walkthrough.companyProfile.welcome.title',
      bodyKey: 'walkthrough.companyProfile.welcome.body',
      placement: 'bottom-start',
    },
    {
      target: PROFILE_TOUR_TARGETS.header,
      titleKey: 'walkthrough.companyProfile.header.title',
      bodyKey: 'walkthrough.companyProfile.header.body',
      placement: 'bottom',
    },
    {
      target: PROFILE_TOUR_TARGETS.general,
      titleKey: 'walkthrough.companyProfile.general.title',
      bodyKey: 'walkthrough.companyProfile.general.body',
      placement: 'top',
    },
    {
      target: PROFILE_TOUR_TARGETS.locations,
      titleKey: 'walkthrough.companyProfile.locations.title',
      bodyKey: 'walkthrough.companyProfile.locations.body',
      placement: 'top',
    },
    {
      target: PROFILE_TOUR_TARGETS.benefits,
      titleKey: 'walkthrough.companyProfile.benefits.title',
      bodyKey: 'walkthrough.companyProfile.benefits.body',
      placement: 'top',
    },
    {
      target: PROFILE_TOUR_TARGETS.media,
      titleKey: 'walkthrough.companyProfile.media.title',
      bodyKey: 'walkthrough.companyProfile.media.body',
      placement: 'top',
    },
    {
      target: PROFILE_TOUR_TARGETS.edit,
      titleKey: 'walkthrough.companyProfile.edit.title',
      bodyKey: 'walkthrough.companyProfile.edit.body',
      placement: 'left',
    },
  ],
};
